import { api as supervisingApi } from "../api";
import { ProcessedDataResponse } from "./types";

export const processedDataApi = supervisingApi.injectEndpoints({
    endpoints: (build) => ({
        getProcessedData: build.query<ProcessedDataResponse, number>({
            query: (id: number) => ({
                url: `api/v1/supervising/processed_data/${id}`,
            }),
        }),
    }),
});

export const { useGetProcessedDataQuery } = processedDataApi;
